import React, { useEffect, useState, useRef } from "react";
import "../styles/CreateRequisition.scss";
import { useNavigate, useParams } from "react-router-dom";
import Select, { components } from "react-select";
import Swal from "sweetalert2";
import { Country, State, City } from "country-state-city";
import {
  getAllDepartments,
  getAllJobTypes,
  getAllSkills,
  getRequisition,
  getRecruiterMappings,
  getActiveClients,
  updateRequisition,
  getAllRecruiters,
  reconcileAllocations,
} from "../services/api";
function EditRequisition() {
  const { id: requisitionId } = useParams();
  const [form, setForm] = useState({
    job_id: "",
    job_title: "",
    departments: [],
    client_id: "",
    client_name: "",
    client_website: "",
    min_budget: "",
    max_budget: "",
    workmode: "",
    job_type: [],
    openings: "",
    locations: "",
    notice_period_days: "",
    job_desc: "",
    skills: [],
    skillInput: "",
    years_of_exp: "",
    remarks: "",
    status: "",
    master_status: "",
    is_active: true,
  });

  const [error, setError] = useState("");
  const [skillOptions, setSkillOptions] = useState([]);
  const [assignedRecruiters, setAssignedRecruiters] = useState([]);
  const [allocationWarning, setAllocationWarning] = useState(false);
  const [initialOpenings, setInitialOpenings] = useState(null);
  const [locationOptions, setLocationOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [jobTypeOptions, setJobTypeOptions] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);
  const [optionsLoaded, setOptionsLoaded] = useState(false);
  const initialFormRef = useRef(null);
  const navigate = useNavigate();
  
  // Recruiter Allocation Modal State
  const [recruiterModalOpen, setRecruiterModalOpen] = useState(false);
  const [selectedRecruiters, setSelectedRecruiters] = useState([]);
  const [recruiterTargets, setRecruiterTargets] = useState({});
  const [originalSelectedRecruiters, setOriginalSelectedRecruiters] = useState([]);
  const [originalRecruiterTargets, setOriginalRecruiterTargets] = useState({});
  const [recruiterOptions, setRecruiterOptions] = useState([]);
  const [recruiterMenuOpen, setRecruiterMenuOpen] = useState(false);
  const [isLocked, setLocked] = useState(false);
  const [cancelLocked, setCancelLocked] = useState(false);
  const [allocationAccessGranted, setAllocationAccessGranted] = useState(true);
  const [submissionCounts, setSubmissionCounts] = useState({});
  const [joinedCounts, setJoinedCounts] = useState({});
  const [closedOpenings, setClosedOpenings] = useState(0);
  const suppressValidationRef = useRef(false);

  const isOriginalRecruiter = (id) => {
    if (!originalSelectedRecruiters || originalSelectedRecruiters.length === 0) return false;
    return originalSelectedRecruiters.some((r) => String(r.value) === String(id));
  };

  const roleId = localStorage.getItem("role_id");
  const userData = localStorage.getItem("userData");
  const userId = userData ? JSON.parse(userData)?.user?.id : null;

  const CheckboxOption = (props) => (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
        style={{ marginRight: 8 }}
      />
      <label>{props.label}</label>
    </components.Option>
  );

  //  Fetch requisition details
  useEffect(() => {
    (async () => {
      try {
        //  Show loading spinner
        Swal.fire({
          html: `<img src=${require("../assets/loader.gif")} style="width: 50px" alt="loader">`,
          showConfirmButton: false,
          heightAuto: false,
          customClass: { popup: "loader-swal" },
          allowOutsideClick: false,
        });

        // API Call
        const res = await getRequisition(requisitionId);
        Swal.close();

        // On Success
        if (res?.result_code === 200 && res?.result_info) {
          const r = res.result_info;
          const client = res.client || {};
          const normalizeWorkmode = (value) => {
          if (!value) return "";
         const trimmed = value.trim().toLowerCase();
          if (trimmed === "work from office") return " Work From Office ";
          if (trimmed === "remote") return " Remote ";
           if (trimmed === "hybrid") return " Hybrid ";
            return value; // fallback to original
               };

          const initialFormData = {
            job_id: r.job_id || "",
            job_title: r.job_title || "",
            departments: Array.isArray(r.department_ids)
              ? r.department_ids.map(String)
              : r.departments
              ? String(r.departments)
                  .split(",")
                  .map((s) => s.trim())
              : [],
            client_id: client.id ? String(client.id) : "",
            client_name: client.name || "",
            client_website: client.website || "",
            min_budget: r.min_budget ? String(r.min_budget) : "",
            workmode: r.workmode ? normalizeWorkmode(r.workmode) : "",
            max_budget: r.max_budget ? String(r.max_budget) : "",
            job_type: Array.isArray(r.job_type_ids)
              ? r.job_type_ids.map(String)
              : r.job_type
              ? String(r.job_type)
                  .split(",")
                  .map((s) => s.trim())
              : [],
            openings:
              r.openings !== undefined && r.openings !== null
                ? String(r.openings)
                : "",
            locations: r.locations
                ? String(r.locations)
                .split(",")
                .map((s) => s.trim())
                : [],
            notice_period_days: r.notice_period_days!== undefined && r.notice_period_days!== null
              ? String(r.notice_period_days)
              : "",
            job_desc: r.job_desc || "",
            skills: r.skills ? r.skills.split(/, ?/) : [],
            skillInput: "",
            years_of_exp:
              r.years_of_exp !== undefined && r.years_of_exp !== null
                ? String(r.years_of_exp)
                : "",
            remarks: r.remarks || "",
            status: r.status || "",
            master_status: r.master_status || r.status || "",
            is_active: r.is_active !== undefined ? r.is_active : true,
          };
          initialFormRef.current = initialFormData;
          setForm(initialFormData);
          // record initial openings from master for compare when user edits (uses master_openings not child openings)
          setInitialOpenings(
            r.master_openings !== undefined && r.master_openings !== null ? Number(r.master_openings) : 0
          );
          // FR 3.6.2 — closed openings from backend
          setClosedOpenings(r.closed_openings || 0);

          const formRecruiters =
            r.recruiter_details && Array.isArray(r.recruiter_details)
              ? r.recruiter_details
              : [];
          let allRecruiters = [...formRecruiters];

        try {
  const mappingRes = await getRecruiterMappings(requisitionId);
  if (
    mappingRes?.result_code === 200 &&
    mappingRes?.result_info?.recruiter_details
  ) {
    allRecruiters.push(...mappingRes.result_info.recruiter_details);

    //  Set joinedCounts immediately on page load so Current Openings is accurate
    if (mappingRes.result_info.joined_counts) {
      setJoinedCounts(mappingRes.result_info.joined_counts);
    }
  }
} catch (fetchError) {
  console.error("Error fetching recruiter mappings:", fetchError);
}

          const uniqueRecruiters = Array.from(
            new Map(
              allRecruiters.map((rec) => {
                const key = rec.id
                  ? `id_${rec.id}`
                  : `name_${String(rec.name || rec.email || rec).trim()}`;
                return [key, rec];
              })
            ).values()
          );
          setAssignedRecruiters(uniqueRecruiters);
          const initialTargets = {};
          uniqueRecruiters.forEach(r => {
            if (r.id !== undefined && r.recruiter_target !== undefined) {
              initialTargets[String(r.id)] = r.recruiter_target;
            }
          });
          setRecruiterTargets(prev => ({ ...initialTargets, ...prev }));
        } else {
          //  If response structure is unexpected or error
          Swal.fire({
            icon: "error",
            title: "Failed to load requisition",
            text: res?.error_info || "Unable to fetch requisition details.",
            confirmButtonColor: "#d33",
          });
          setError("Failed to fetch requisition details.");
        }
      } catch (error) {
        Swal.close();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong while fetching requisition details.",
          confirmButtonColor: "#d33",
        });
        setError("Failed to fetch requisition details.");
      } finally {
        // setLoading(false);
      }
    })();
  }, [requisitionId]);

  useEffect(() => {
    if (initialOpenings === null) return;
    const openingsChanged = Number(form.openings || 0) !== Number(initialOpenings || 0);
    setAllocationAccessGranted(!openingsChanged);
  }, [form.openings, initialOpenings]);

  // Fetch recruiters for Hiring Manager
  useEffect(() => {
    if (roleId === "3") {
      const fetchRecruiters = async () => {
        try {
          const res = await getAllRecruiters();
          if (res?.status === "S" && Array.isArray(res.result_info)) {
            setRecruiterOptions(
              res.result_info.map((u) => ({
                value: u.id,
                label: u.name,
                id: u.id,
                email: u.email,
              }))
            );
          }
        } catch (error) {
          console.error("Error fetching recruiters:", error);
        }
      };
      fetchRecruiters();
    }
  }, [roleId]);

  const hasAnyChanges = () => {
    if (!initialFormRef.current) return false;

    const normalizeValue = (value) => {
      if (Array.isArray(value)) {
        return [...value].map((item) => String(item)).sort().join("|");
      }
      if (value === null || value === undefined) {
        return "";
      }
      return String(value).trim();
    };

    const currentSnapshot = {
      job_id: normalizeValue(form.job_id),
      job_title: normalizeValue(form.job_title),
      departments: normalizeValue(form.departments),
      client_id: normalizeValue(form.client_id),
      min_budget: normalizeValue(form.min_budget),
      max_budget: normalizeValue(form.max_budget),
      workmode: normalizeValue(form.workmode),
      job_type: normalizeValue(form.job_type),
      openings: normalizeValue(form.openings),
      locations: normalizeValue(form.locations),
      notice_period_days: normalizeValue(form.notice_period_days),
      job_desc: normalizeValue(form.job_desc),
      skills: normalizeValue(form.skills),
      years_of_exp: normalizeValue(form.years_of_exp),
      remarks: normalizeValue(form.remarks),
    };

    const initialSnapshot = {
      job_id: normalizeValue(initialFormRef.current.job_id),
      job_title: normalizeValue(initialFormRef.current.job_title),
      departments: normalizeValue(initialFormRef.current.departments),
      client_id: normalizeValue(initialFormRef.current.client_id),
      min_budget: normalizeValue(initialFormRef.current.min_budget),
      max_budget: normalizeValue(initialFormRef.current.max_budget),
      workmode: normalizeValue(initialFormRef.current.workmode),
      job_type: normalizeValue(initialFormRef.current.job_type),
      openings: normalizeValue(initialFormRef.current.openings),
      locations: normalizeValue(initialFormRef.current.locations),
      notice_period_days: normalizeValue(initialFormRef.current.notice_period_days),
      job_desc: normalizeValue(initialFormRef.current.job_desc),
      skills: normalizeValue(initialFormRef.current.skills),
      years_of_exp: normalizeValue(initialFormRef.current.years_of_exp),
      remarks: normalizeValue(initialFormRef.current.remarks),
    };

    return JSON.stringify(currentSnapshot) !== JSON.stringify(initialSnapshot);
  };

  // Helper: Check if total recruiter targets exceed openings
  const checkExceeded = (recruiter, newValue) => {
    const numVal = parseInt(newValue) || 0;
    const currentTotal = selectedRecruiters.reduce(
      (sum, r) => sum + (Number(recruiterTargets[r.value] || 0)),
      0
    );
    const currentVal = Number(recruiterTargets[recruiter.value] || 0);

    if (numVal <= currentVal) {
      return false;
    }

    const newTotal = currentTotal - currentVal + numVal;
    if (newTotal > Number(form.openings || 0)) {
      if (!suppressValidationRef.current) {
        suppressValidationRef.current = true;
        Swal.fire({
          icon: "warning",
          title: "Exceeded openings",
          text: "Allocation cannot exceed the number of openings for this requisition.",
          allowOutsideClick: false,
        });
        setTimeout(() => {
          suppressValidationRef.current = false;
        }, 300);
      }
      return true;
    }
    return false;
  };

  // Helper: Update recruiter target value
  const validateAndSetRecruiterTarget = (recruiter, value) => {
    if (suppressValidationRef.current) return;
    // allow empty input for newly selected recruiters
    if (value === "") {
      setRecruiterTargets((prev) => ({ ...prev, [recruiter.value]: "" }));
      return;
    }
    const parsed = parseInt(value);
    if (isNaN(parsed)) return;
    const numVal = parsed;
    // prevent 0 for newly selected recruiters
    const minAllowed = isOriginalRecruiter(recruiter.value) ? 0 : 1;
    if (numVal < minAllowed) return;
    setRecruiterTargets((prev) => ({
      ...prev,
      [recruiter.value]: numVal,
    }));
  };

  // Helper: Change recruiter target by increment/decrement
  const changeRecruiterTarget = (recruiter, delta) => {
    const raw = recruiterTargets[recruiter.value];
    const isOrig = isOriginalRecruiter(recruiter.value);
    const minAllowed = isOrig ? 0 : 1;
    // if value is empty or undefined, + should set to minAllowed, - should do nothing
    if (raw === undefined || raw === "") {
      if (delta <= 0) return;
      setRecruiterTargets((prev) => ({ ...prev, [recruiter.value]: minAllowed }));
      return;
    }
    const current = Number(raw);
    const newValue = current + delta;
    if (newValue < minAllowed) return;

    if (delta < 0) {
      setRecruiterTargets((prev) => ({
        ...prev,
        [recruiter.value]: newValue,
      }));
      return;
    }

    const currentTotal = selectedRecruiters.reduce(
      (sum, r) => sum + (Number(recruiterTargets[r.value] || 0)),
      0
    );
    const currentVal = Number(recruiterTargets[recruiter.value] || 0);
    const newTotal = currentTotal - currentVal + newValue;
    const maxOpenings = Number(form.openings || 0);

    if (newTotal > maxOpenings) {
      Swal.fire({
        icon: "warning",
        title: "Exceeded openings",
        text: `Allocation cannot exceed the number of openings (${form.openings}) for this requisition.`,
        allowOutsideClick: false,
      });
      return;
    }
    setRecruiterTargets((prev) => ({
      ...prev,
      [recruiter.value]: newValue,
    }));
  };

  // Total assigned across assignedRecruiters (used for display & validation)
  const totalAssigned = assignedRecruiters.reduce((sum, r) => {
    const key = String(r.id || r.value || r);
    return sum + Number(recruiterTargets[key] || 0);
  }, 0);

  const openingsNum = Number(form.openings || 0);
  const openingsBelowClosed = openingsNum < Number(closedOpenings || 0);
  const allocationExceeds = totalAssigned > openingsNum;
  const allocationLessThanOpenings = totalAssigned !== openingsNum;
  const targetAllocationDisabled =
    (initialOpenings !== null &&
      Number(form.openings || 0) !== Number(initialOpenings || 0) &&
      !allocationAccessGranted) ||
    openingsBelowClosed;

  const hasAllocationChanges = () => {
    const origIds = (originalSelectedRecruiters || []).map((r) => String(r.value || r.id)).sort();
    const newIds = (selectedRecruiters || []).map((r) => String(r.value)).sort();

    if (origIds.length !== newIds.length) return true;
    for (let i = 0; i < origIds.length; i += 1) {
      if (origIds[i] !== newIds[i]) return true;
    }

    const origKeys = Object.keys(originalRecruiterTargets || {}).sort();
    const newKeys = Object.keys(recruiterTargets || {}).sort();

    if (origKeys.length !== newKeys.length) return true;
    for (let i = 0; i < origKeys.length; i += 1) {
      if (origKeys[i] !== newKeys[i]) return true;
    }

    for (const key of newKeys) {
      if (String(originalRecruiterTargets[key] || "") !== String(recruiterTargets[key] || "")) {
        return true;
      }
    }

    return false;
  };

  // Handle allocation reconciliation
const handleReconcileAllocations = async () => {

  if (selectedRecruiters.length === 0) {
    Swal.fire("Error", "Select at least one recruiter", "warning");
    return;
  }

  const totalTargets = selectedRecruiters.reduce(
    (sum, r) => sum + Number(recruiterTargets[String(r.value)] || 0),
    0
  );

  if (totalTargets > Number(form.openings || 0)) {
    Swal.fire({
      icon: "error",
      title: "Exceeded openings",
      text: `Allocation cannot exceed the number of openings (${form.openings}) for this requisition.`,
    });
    return;
  }
   if (!hasAllocationChanges()) {
    await Swal.fire({
      icon: "info",
      title: "No changes made",
      text: "No changes are made in selected recruiters or targets.",
      confirmButtonColor: "#0078b9",
    });
    setRecruiterModalOpen(false);
    setSelectedRecruiters([]);
    setRecruiterTargets({});
    setCancelLocked(false);
    return;
  }

  // All selected recruiters must have a target >= 0
  // (target = 0 is allowed — it means Hold per FR 3.6.8)
  const hasInvalidTarget = selectedRecruiters.some((r) => {
  const val = recruiterTargets[String(r.value)];
  return val === undefined || val === "";
});

if (hasInvalidTarget) {
  Swal.fire("Error", "Please enter a valid target for all recruiters (0 or more)", "warning");
  return;
}

// — target cannot be set below No. of Selections (joined count)
const belowSelections = selectedRecruiters.find((r) => {
  const target = Number(recruiterTargets[String(r.value)] || 0);
  const selections = Number(joinedCounts[String(r.value)] || 0);
  return target < selections;
});

if (belowSelections) {
  const selections = joinedCounts[String(belowSelections.value)] || 0;
  Swal.fire({
    icon: "error",
    title: "Target Below Selections",
    text: `${belowSelections.label} has ${selections} candidate(s) in Joined status. Target allocation cannot be set below ${selections}.`,
  });
  return;
}
  // Recruiters being set to 0 — backend will put their CJID on Hold (FR 3.6.4)
const zeroTargetRecruiters = selectedRecruiters
  .filter((r) => Number(recruiterTargets[String(r.value)] || 0) === 0)
  .map((r) => Number(r.value));

const payload = {
  requisition_id: Number(requisitionId),
  recruiters: selectedRecruiters.map((r) => Number(r.value)),
  recruiter_targets: selectedRecruiters.reduce((acc, r) => {
    acc[String(r.value)] = Number(recruiterTargets[String(r.value)] || 0);
    return acc;
  }, {}),
  zero_target_recruiters: zeroTargetRecruiters, // FR 3.6.4 — backend sets CJID to Hold
  assigned_by: Number(userId || 1),
};

  try {
    const res = await reconcileAllocations(payload);

    if (res?.result_code === 200 || res?.status === "S") {
  // Refresh mappings
  const mappingRes = await getRecruiterMappings(requisitionId);
  if (mappingRes?.result_code === 200 && mappingRes?.result_info) {
    const { recruiter_details = [], joined_counts = {} } = mappingRes.result_info;

    const targetsMap = {};
    recruiter_details.forEach(rec => {
      targetsMap[String(rec.id)] = rec.recruiter_target ?? 0;
    });

    setAssignedRecruiters(recruiter_details);
    setRecruiterTargets(targetsMap);
    setJoinedCounts(joined_counts);
  }

  setRecruiterModalOpen(false);
  setSelectedRecruiters([]);
  setCancelLocked(false);

  await Swal.fire({ icon: 'success', title: 'Saved', text: 'Allocations saved successfully' });
  navigate('/requisitions');

    } else {
      Swal.fire("Error", res?.message || "Failed to save allocations", "error");
    }
  } catch (error) {
    console.error(error);
    Swal.fire("Error", "Something went wrong", "error");
  }
};
  // Open allocation modal with current recruiter mappings
  const openAllocationModal = async () => {
  if (Number(form.openings || 0) < Number(closedOpenings || 0)) {
    Swal.fire({
      icon: "error",
      title: "Validation Error",
      text: "Total Openings shall be greater than or equal to Closed Openings",
    });
    return;
  }

  try {
    // Make sure recruiter options are loaded
    if (roleId === "3" && recruiterOptions.length === 0) {
      const recruiterRes = await getAllRecruiters();
      if (recruiterRes?.status === "S" && Array.isArray(recruiterRes.result_info)) {
        setRecruiterOptions(
          recruiterRes.result_info.map((u) => ({
            value: u.id,
            label: u.name,
            id: u.id,
            email: u.email,
          }))
        );
      }
    }

    const mappingsResponse = await getRecruiterMappings(requisitionId);

    if (mappingsResponse?.result_code === 200 && mappingsResponse?.result_info) {
      const {
        recruiter_details = [],
        recruiter_targets = {},
        submission_counts = {},
        joined_counts = {},
      } = mappingsResponse.result_info;

      // Build selectedRecruiters list from recruiter_details
      const selectedFromMapping = recruiter_details.map((rec) => ({
        value: Number(rec.id),
        label: rec.name,
        status: rec.status,
      }));

      // Build targets map from recruiter_details (use recruiter id as key)
      const targetsFromMapping = {};
      recruiter_details.forEach((rec) => {
        targetsFromMapping[String(rec.id)] = rec.recruiter_target ?? 0;
      });

      setSelectedRecruiters(selectedFromMapping);
      setRecruiterTargets(targetsFromMapping);
      setSubmissionCounts(submission_counts);
      setJoinedCounts(joined_counts);
      setOriginalSelectedRecruiters(selectedFromMapping);
      setOriginalRecruiterTargets(targetsFromMapping);
    } else {
      // No mappings yet — open empty modal
      setSelectedRecruiters([]);
      setRecruiterTargets({});
      setSubmissionCounts({});
      setJoinedCounts({});
    }

    setRecruiterModalOpen(true);
    setCancelLocked(false);

  } catch (error) {
    console.error("Error opening allocation modal:", error);
    setSelectedRecruiters([]);
    setRecruiterTargets({});
    setSubmissionCounts({});
    setJoinedCounts({});
    setRecruiterModalOpen(true);
    setCancelLocked(false);
  }
};

  const removeRecruiter = async (rec) => {
    const result = await Swal.fire({
      title: 'Remove recruiter?',
      html: `Removed recruiter will retain read-only access to this requisition and cannot submit new candidates. Do you want to remove <strong>${rec.name}</strong>?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Remove',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      // remove from list and zero out their target
      const key = String(rec.id);
      setAssignedRecruiters((prev) => prev.filter((r) => String(r.id) !== key));
      setRecruiterTargets((prev) => {
        const copy = { ...prev };
        delete copy[key];
        return copy;
      });
    }
  };

  const totalAssignedTargets = selectedRecruiters.reduce(
    (sum, r) => sum + Number(recruiterTargets[r.value] || 0),
    0
  );
  useEffect(() => {
    if (totalAssignedTargets > openingsNum) {
      setCancelLocked(true);
    }
  }, [totalAssignedTargets, openingsNum]);
  const cancelDisabled = cancelLocked;

  const handleSkillsChange = (selected) => {
    setForm((f) => ({
      ...f,
      skills: Array.isArray(selected) ? selected.map((opt) => opt.value) : [],
    }));
  };

  const handleJobTypeChange = (selected) => {
    // Job Type is not isMulti, so selected is a single object or null
    setForm((f) => ({
      ...f,
      job_type: selected ? [selected.value] : [],
    }));
  };

  const handleLocationsChange = (selected) => {
    setForm((f) => ({
      ...f,
      locations: selected ? selected.map((item) => item.value) : [],
    }));
  };

  const handleDepartmentChange = (selected) => {
    setForm((f) => ({
      ...f,
      departments: Array.isArray(selected) ? selected.map((opt) => opt.value) : [],
    }));
  };

  // For Departments, Job Types, Skills, Locations, Recruiters
  const fetchSkills = async (query) => {
    try {
      const response = await getAllSkills();
      if (
        response &&
        response.result_code === 200 &&
        Array.isArray(response.result_info)
      ) {
        const allSkills = response.result_info.map(
          (skill) => skill.skill_name || skill.name || skill
        );
        if (!query) return allSkills;
        return allSkills.filter((skill) =>
          skill.toLowerCase().includes(query.toLowerCase())
        );
      }
      return [];
    } catch (error) {
      console.error("Error fetching skills:", error);
      return [];
    }
  };

  // Function to get Indian cities
  const getIndianCities = () => {
    try {
      // Get India country code
      const india = Country.getCountryByCode("IN");
      if (!india) return [];

      // Get all states of India
      const indianStates = State.getStatesOfCountry("IN");
      if (!indianStates || indianStates.length === 0) return [];

      // Get cities from all states
          const extraCities = ["Bhuwaneshwar"]; 
           const removeCities = ["Bangalore Urban", "Bangalore Rural", "Ghandhi Nagar","Lucknow District"];
     
     
            const removeSet = new Set(
                [...extraCities, ...removeCities].map(city => city.toLowerCase())
                   );
     
                 const existingCities = new Set();
                  let allCities = [];
     
                  indianStates.forEach((state) => {
                  const cities = City.getCitiesOfState("IN", state.isoCode);
     
                   if (!cities || cities.length === 0) return;
     
                  cities.forEach((city) => {
                  const name = city?.name?.trim();
                   const key = name?.toLowerCase();
     
                    if (
                        name &&
                        key &&
                        !existingCities.has(key) &&
                        !removeSet.has(key)
                          ) {
                        existingCities.add(key);
     
                        allCities.push({
                        value: name,
                        label: name,
                           });
                        }
                      });
                   });
     
     
                 allCities.push({
                     value: "Remote",
                     label: "Remote",
                          });
     
    
                  allCities.sort((a, b) => a.label.localeCompare(b.label));
     
                return allCities;
    } catch (error) {
      console.error("Error fetching Indian cities:", error);
      return [];
    }
  };

  useEffect(() => {
    let active = true;
    let loaded = {
      skills: false,
      departments: false,
      jobTypes: false,
      locations: false,
      clients: false,
    };

    // 🔹 Fetch Skills
    fetchSkills("").then((skills) => {
      if (active && Array.isArray(skills)) {
        setSkillOptions(skills.map((s) => ({ value: s, label: s })));
        loaded.skills = true;
        checkLoaded();
      }
    });

    // 🔹 Fetch Departments
    getAllDepartments().then((res) => {
      if (active) {
        if (res?.status === "S" && Array.isArray(res.result_info)) {
          setDepartmentOptions(
            res.result_info.map((dept) => ({
              value: String(dept.id),
              label: dept.name,
            }))
          );
        } else {
          setDepartmentOptions([]);
        }
        loaded.departments = true;
        checkLoaded();
      }
    });

    // 🔹 Fetch Job Types
    getAllJobTypes().then((res) => {
      if (active) {
        if (res?.status === "S" && Array.isArray(res.result_info)) {
          setJobTypeOptions(
            res.result_info.map((jobType) => ({
              value: String(jobType.id),
              label: jobType.name,
            }))
          );
        } else {
          setJobTypeOptions([]);
        }
        loaded.jobTypes = true;
        checkLoaded();
      }
    });

    // 🔹 Fetch Indian Cities
    const indianCities = getIndianCities();
    if (active) {
      setLocationOptions(indianCities);
      loaded.locations = true;
      checkLoaded();
    }

    // 🔹 Fetch Active Clients
    getActiveClients().then((res) => {
      if (active) {
        if (res?.status === "S" && Array.isArray(res.result_info)) {
          setClientOptions(
            res.result_info.map((client) => ({
              value: String(client.id),
              label: client.name,
              website: client.website,
            }))
          );
        } else {
          setClientOptions([]);
        }
        loaded.clients = true;
        checkLoaded();
      }
    });

    function checkLoaded() {
      if (Object.values(loaded).every(Boolean)) {
        setOptionsLoaded(true);
      }
    }

    return () => {
      active = false;
    };
  }, []);

const isEditable = roleId === "3";
  if (!optionsLoaded) {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        Loading requisition data...
      </div>
    );
  }

  return (
    <>
      <div className="create-requisition-container">
      <h2 style={{ fontWeight: 600, fontSize: "1.4rem" }}>Edit Requisition</h2>
      {/* Basic Information */}
      {roleId !== "4" && (
        <>
          <div className="create-requisition-section">
            <div className="create-requisition-section-title">
              <span role="img" aria-label="info">
                🔵
              </span>{" "}
              Basic Information
            </div>
            <div className="create-requisition-row">
              <div className="create-requisition-field">
                <label>Job ID *</label>
                <input
                  name="job_id"
                  value={form.job_id || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    const hasScript = /<script.*?>/i.test(value);
                    if (!hasScript) {
                      setForm((prev) => ({ ...prev, job_id: value }));
                    }
                  }}
                  placeholder="Enter Job ID"
                  required
                  className="custom-placeholder"
                  autoComplete="off"
                  disabled
                />
              </div>
              <div className="create-requisition-field">
                  <label>Job Title *</label>
                      <input
                          name="job_title"
                          value={form.job_title}
                          onChange={(e) => {
                            const value = e.target.value;

     
                            const hasScript = /<script.*?>/i.test(value);

                            if (!hasScript) {
                                    setForm((prev) => ({
                                     ...prev,
                                     job_title: value,
                                               }));
                                           }
                                        }}
                                 placeholder="Enter job title"
                                 required
                                 className="custom-placeholder"
                                 autoComplete="off"
                                        />
                        </div>        
             </div>
            <div className="create-requisition-row">
              <div className="create-requisition-field">
                <label>Department * </label>
                <Select
               options={departmentOptions}
               value={
              departmentOptions.find(
                 (opt) =>
              String(opt.value) ===
            String(
                Array.isArray(form.departments)
                 ? form.departments[0]
              : form.departments
             )
           ) || null
            }
           onChange={(selected) =>
            setForm((f) => ({
                          ...f,
                        departments: selected ? [String(selected.value)] : [],
                              }))
                                                    }
           placeholder="Select department"
           isSearchable={false}
           classNamePrefix="react-select"
           styles={{ menu: (base) => ({ ...base, zIndex: 9999 }) }}
           isDisabled={!isEditable}
           />
              </div>
              {assignedRecruiters?.length > 0 && (
                <div className="create-requisition-field">
                  <label>Recruiters *</label>
                  <div
                    style={{
                      padding: "8px 12px",
                      border: "1px solid #d1d5db",
                      borderRadius: "6px",
                      backgroundColor: "#f9fafb",
                      minHeight: "38px",
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: "4px",
                    }}
                  >
                    {assignedRecruiters.map((recruiter, index) => (
                      <span
                        key={recruiter.id || index}
                        style={{
                          background: "#e5e7eb",
                          padding: "2px 8px",
                          borderRadius: "4px",
                          fontSize: "0.875rem",
                          color: "#374151",
                        }}
                      >
                        {recruiter.name}
                      </span>
                    ))}
                  </div>
                  {/* <div style={{ fontSize: 12, color: "#6b7280", marginTop: 4 }}>
                    Allocated:{" "}
                    {Object.values(recruiterTargets).reduce((s, v) => s + (Number(v) || 0), 0)}
                    {" / "}
                    {form.openings || 0} openings
                  </div> */}
                </div>
              )}
            </div>
            <div className="create-requisition-row">
                <div className="create-requisition-field">
                <label> Total Openings *</label>
                <input
                  name="openings"
                  type="text"
                  value={form.openings}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      // Validate against closed openings
                      if (value !== "" && Number(value) < closedOpenings) {
                        Swal.fire({
                          icon: "Warning",
                          title: "Invalid Openings",
                          text: `Total Openings shall be greater than or equal to Closed Openings`,
                          confirmButtonColor: "#d33",
                        });
                        return;
                      }
                      setForm(f => ({ ...f, openings: value }));
                      const totalAlloc = Object.values(recruiterTargets).reduce(
                        (sum, v) => sum + (Number(v) || 0), 0
                      );
                      setAllocationWarning(
                        value !== "" &&
                          Number(value) >= Number(closedOpenings || 0) &&
                          Number(value) < totalAlloc
                      );
                    }
                  }}
                  autoComplete="off"
                  placeholder="Openings"
                  className="custom-placeholder"
                />
              </div>
              <div className="create-requisition-field">
                <label>Current Openings</label>
                <input
                  name="currentOpenings"
                  type="text"
                  value={Math.max(
                    (Number(initialOpenings || 0) || 0) - 
                    (Object.values(joinedCounts || {}).reduce((sum, count) => sum + Number(count || 0), 0) || 0),
                    0
                  )}
                  disabled
                  autoComplete="off"
                  placeholder="Current Openings"
                  className="custom-placeholder"
                  style={{ backgroundColor: "#f3f4f6", cursor: "not-allowed" }}
                />
              </div>
              <div className="create-requisition-field">
                <label>Experience Level (Years) *</label>
                {/* <Select
                options={experienceOptions}
                value={
                  experienceOptions.find(
                    (opt) => opt.value === Number(form.years_of_exp)
                  ) || null
                }
                onChange={(selected) =>
                  setForm((f) => ({
                    ...f,
                    years_of_exp: selected ? selected.value : "",
                  }))
                }
                placeholder="Select experience level"
                isSearchable={true}
                classNamePrefix="react-select"
                styles={{
                  menu: (base) => ({ ...base, zIndex: 9999 }),
                  control: (base) => ({
                    ...base,
                    padding: "0.2rem 0rem",
                  }),
                }}
                isClearable
                isDisabled
              /> */}
                <input
                  name="experience"
                  type="text"
                  min="0"
                  value={form.years_of_exp}
                  onChange={(ev) => {
                    const value = ev.target.value;
                    const digitOnlyPattern = /^\d*$/; // Allow any number of digits
                    if (digitOnlyPattern.test(value)) {
                      setForm((prev) => ({
                        ...prev,
                        years_of_exp: value,
                        notice_period_days: Number(value) === 0 ? "" : prev.notice_period_days, 
                      }));
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                      e.preventDefault();
                    }
                  }}
                  // maxLength={255}
                  disabled={!isEditable}
                  autoComplete="off"
                  placeholder="Enter years of experience"
                  className="custom-placeholder"
                />
              </div>
            </div>
          </div>
          {/* Job Details */}
          <div className="create-requisition-section">
            <div className="create-requisition-section-title">
              <span role="img" aria-label="details">
                🟦
              </span>{" "}
              Job Details
            </div>
            <div className="create-requisition-row">
              <div className="create-requisition-field" style={{ flex: 2 }}>
                <label>Job Description *</label>
                <textarea
                  name="job_desc"
                  value={form.job_desc}
                
                   onChange={(e) => {
               const value = e.target.value;
               const hasScript = /<script.*?>/i.test(value);

                                if (!hasScript) {
                                          setForm((prev) => ({
                                          ...prev,
                                          job_desc: value,
                                                }));
                                            }

                                        }}
                  disabled={!isEditable}
                  placeholder="Provide a detailed description of the role, responsibilities, and requirements..."
                  rows="4"
                  className="custom-placeholder"
                />
              </div>
            </div>
            <div className="create-requisition-row">
              <div className="create-requisition-field" style={{ flex: 2 }}>
                <label>Skills *</label>
                <Select
                  isMulti
                  options={skillOptions}
                  value={skillOptions.filter((opt) =>
                    form.skills.includes(opt.value)
                  )}
                  onChange={handleSkillsChange}
                  placeholder="Select or type skills"
                  isSearchable={true}
                  classNamePrefix="react-select"
                  styles={{
                    menu: (base) => ({ ...base, zIndex: 9999 }),
                    control: (base) => ({
                      ...base,
                      padding: "0.2rem 0rem",
                    }),
                  }}
                  isDisabled={!isEditable}
                />
              </div>
            </div>
            <div className="create-requisition-row">
              <div className="create-requisition-field">
                <label>Job Type *</label>
                <Select
                  options={jobTypeOptions}
                  value={(() => {
                    const types = Array.isArray(form.job_type)
                      ? form.job_type.map(String)
                      : form.job_type
                      ? String(form.job_type).split(",").map((s) => s.trim())
                      : [];
                    return (
                      jobTypeOptions.find((opt) =>
                        types.map(String).includes(String(opt.value))
                      ) || null
                    );
                  })()}
                  onChange={handleJobTypeChange}
                  placeholder="Select job type"
                  isSearchable={true}
                  classNamePrefix="react-select"
                  styles={{
                    menu: (base) => ({ ...base, zIndex: 9999 }),
                    control: (base) => ({
                      ...base,
                      padding: "0.2rem 0rem",
                    }),
                  }}
                  isDisabled={!isEditable}
                />
              </div>
              <div className="create-requisition-field">
        <label>Work Mode *</label>
  <div className="workmode_options">
    {[" Work From Office ", " Remote ", " Hybrid "].map((item) => (
      <label
        key={item}
        className={`workmode-card ${
          form.workmode === item ? "active" : ""
        }`}
      >
        <input
          type="radio"
          name="workmode"
          value={item}
          checked={form.workmode === item}
          onChange={(e) =>
            isEditable && setForm({ ...form, workmode: e.target.value })
          }
          disabled={!isEditable}
        />
        <span className="radio-circle"></span>
        <span className="workmode-text">{item}</span>
      </label>
    ))}
  </div>
</div>   
      </div>
         <div className="create-requisition-row">
          <div className="create-requisition-field">
            <label>Location *</label>
            <Select
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              components={{ Option: CheckboxOption }}
              options={locationOptions}
              value={locationOptions.filter((opt) =>
                  Array.isArray(form.locations) && form.locations.includes(opt.value)
              )}
              onChange={handleLocationsChange}
              onKeyDown={(e) => {if (e.key === "Enter") {e.preventDefault(); }}}
              placeholder="Select location"
              isSearchable={true}
              isClearable={true}
              classNamePrefix="react-select"
              styles={{ menu: (base) => ({...base, zIndex: 9999, }), option: (base, state) => ({
                       ...base,backgroundColor: state.isSelected? "white": state.isFocused
                       ? "#f5f5f5": "white", color: "black", }),}}
                   />
          </div>
        </div>  
            <div className="create-requisition-row">
              <div className="create-requisition-field">
                <label>Min Budget (in lakhs) *</label>
                <input
                  type="text"
                  name="min_budget"
                  value={form.min_budget}
                  onChange={(ev) => {
                    const value = ev.target.value;
                    const isValidNumber = /^\d*\.?\d{0,2}$/.test(value);

                    if (isValidNumber) {
                      setForm({ ...form, min_budget: value });
                    }
                  }}
                  placeholder="Enter minimum budget"
                  required
                  min="0"
                  step="0.01"
                  autoComplete="off"
                 
                />
              </div>
              <div className="create-requisition-field">
                <label>Max Budget (in lakhs) *</label>
                <input
                  type="text"
                  name="max_budget"
                  value={form.max_budget}
                  onChange={(ev) => {
                    const value = ev.target.value;
                    const isValidNumber = /^\d*\.?\d{0,2}$/.test(value);

                    if (isValidNumber) {
                      setForm({ ...form, max_budget: value });
                    }
                  }}
                  placeholder="Enter maximum budget"
                  required
                  min="0"
                  step="0.01"
                  autoComplete="off"             
                />
              </div>
            </div>
            <div className="create-requisition-row">
              <div className="create-requisition-field">
                <label>Notice Period in Days {Number(form.years_of_exp || 0) > 0 && "*"}</label>
                <input
                  type="text"
                  name="notice_period_days"
                  value={form.notice_period_days}
                  disabled={Number(form.years_of_exp || 0) === 0}
                  onChange={(ev) => {
                    const value = ev.target.value;

                    // Only allow numeric values greater than or equal to 0
                    const isValidNumber = /^\d*$/.test(value);

                    if (isValidNumber) {
                      setForm({ ...form, notice_period_days: value });
                    }
                  }}
                  min={1}
                  placeholder="Enter notice period in days"
                  required
                  autoComplete="off"
                />
              </div>
            </div>
          </div>
          {/* Additional Information */}
          <div className="create-requisition-section">
            <div className="create-requisition-section-title">
              <span role="img" aria-label="status">
                🟦
              </span>{" "}
              Additional Information
            </div>
            <div className="create-requisition-row">
              <div className="create-requisition-field">
                <label>Client Name *</label>
                <Select
                  options={clientOptions}
                  value={
                    clientOptions.find((opt) => opt.value === form.client_id) ||
                    null
                  }onChange={(selected) => {
                  if (selected) {
                      setForm((f) => ({
                               ...f,
                client_id: selected.value,
               client_name: selected.label,
               client_website: selected.website || "",
                    }));
                 } else {
                 setForm((f) => ({
                        ...f,
                    client_id: "",
                     client_name: "",
                    client_website: "",
                     }));
                         }
                 }}
                  placeholder="Select client name"
                  isSearchable={true}
                  classNamePrefix="react-select"
                  styles={{
                    menu: (base) => ({ ...base, zIndex: 9999 }),
                    control: (base) => ({
                      ...base,
                      padding: "0.2rem 0rem",
                    }),
                  }}
                  isClearable
                />
              </div>
              <div className="create-requisition-field">
                <label>Client Website *</label>
                <input
                  type="text"
                  name="client_website"
                  value={form.client_website}
                  onChange={(ev) => {
                    const value = ev.target.value;
                    const invalidPattern =
                      /<script.*?>.*?<\/script>|[<>\\{}=:/""'']/i;
                    if (!invalidPattern.test(value)) {
                      setForm({ ...form, client_website: value });
                    }
                  }}
                  placeholder="Client website will be auto-populated"
                  required
                  className="custom-placeholder"
                  autoComplete="off"
                  disabled
                />
              </div>
            </div>

            <div className="create-requisition-row">
              <div className="create-requisition-field" style={{ flex: 2 }}>
                <label>Remarks</label>
                <textarea
                  name="remarks"
                  value={form.remarks}
                  onChange={(ev) => {
                    const value = ev.target.value;
                    const invalidPattern =
                      /<script.*?>.*?<\/script>|[<>\\{}=:/""'']/i;
                    if (!invalidPattern.test(value)) {
                      setForm({ ...form, remarks: value });
                    }
                  }}
                  placeholder="Additional notes or remarks..."
                  rows="3"
                  className="custom-placeholder"
                  autoComplete="off"
                  disabled={!isEditable}
                />
              </div>
            </div>
          </div>

          {error && (
            <div style={{ color: "red", marginBottom: "1rem" }}>{error}</div>
          )}
          <div className="create-requisition-actions">
            <button
              type="button"
              onClick={() => navigate("/requisitions")}
              className="save-btn"
            >
              Go Back
            </button>
            {isEditable && (
              <>
                {/*always-visible Target Allocation button */}
                <button
                  type="button"
                  onClick={openAllocationModal}
                  className="save-btn"
                  disabled={targetAllocationDisabled}
                  style={{
                    marginLeft: 12,
                    background: targetAllocationDisabled ? "#e5e7eb" : "#f0f4ff",
                    color: targetAllocationDisabled ? "#6b7280" : "#0078b9",
                    border: "1px solid #0078b9",
                    cursor: targetAllocationDisabled ? "not-allowed" : "pointer",
                    opacity: targetAllocationDisabled ? 0.7 : 1,
                  }}
                >
                  Target Allocation
                </button>

                <button
                  type="button"
                  onClick={async () => {

              if (!hasAnyChanges()) {
                await Swal.fire({
                  icon: "warning",
                  title: "No changes made",
                  text: "No changes were made to this requisition.",
                  confirmButtonColor: "#0078b9",
                });
                navigate("/requisitions");
                return;
              }

              const validations = [
             {
               condition: !form.job_id?.trim(),
               title: "Missing Job ID",
               text: "Please enter the Job ID.",
                        },
             {
              condition: !form.job_title?.trim(),
              title: "Missing Job Title",
              text: "Please enter the job title.",
              },
             {
             condition: !form.departments || (Array.isArray(form.departments) && form.departments.length === 0),
             title: "Missing Department",
             text: "Please select a department.",
             },
             {
             condition: form.years_of_exp === "" || form.years_of_exp === null || form.years_of_exp === undefined,
             title: "Missing Experience Level",
             text: "Please enter the experience level.",
            },
           {
           condition: !form.job_desc?.trim(),
           title: "Missing Job Description",
           text: "Please enter the job description.",
          },
          {
          condition: !form.skills || form.skills.length === 0,
           title: "Missing Skills",
           text: "Please add at least one skill.",
          },
         {
          condition: !form.job_type || form.job_type.length === 0,
              title: "Missing Job Type",
               text: "Please select a job type.",
             },
            {
         condition: !form.workmode?.trim(),
             title: "Missing Work Mode",
              text: "Please select a work mode.",
            },
           {
        condition: form.locations.length === 0,
            title: "Missing Location",
             text: "Please select a location.",
               },
              {
        condition:
             !form.min_budget ||
             isNaN(Number(form.min_budget)) ||
             Number(form.min_budget) <= 0,
             title: "Invalid Min Budget",
             text: "Please enter a valid minimum budget greater than 0.",
             },
             {
             condition:
             !form.max_budget ||
             isNaN(Number(form.max_budget)) ||
              Number(form.max_budget) <= 0,
              title: "Invalid Max Budget",
               text: "Please enter a valid maximum budget greater than 0.",
                      },
               {
              condition:
               form.min_budget &&
             form.max_budget &&
             !isNaN(Number(form.min_budget)) &&
             !isNaN(Number(form.max_budget)) &&
             Number(form.max_budget) <= Number(form.min_budget),
             title: "Invalid Budget Range",
             text: "Max budget must be greater than min budget.",
                 },
               {
            condition:
                   Number(form.years_of_exp) > 0 &&
                      (
                       form.notice_period_days === "" ||
                       form.notice_period_days === null ||
                       form.notice_period_days === undefined ||
                        Number(form.notice_period_days) < 0
                       ),
                       title: "Missing Notice Period",
                        text: "Please enter a valid notice period.",
                        },
                {
            condition:
                 form.openings === "" ||
                 form.openings === null ||
                Number(form.openings) <= 0,
                title: "Invalid Openings",
                text: "Please enter a valid number of openings.",
                    },
                  {
             condition: !form.client_id,
                 title: "Missing Client",
                 text: "Please select a client name.",
                     },
                    ];

              for (const v of validations) {
                  if (v.condition) {
                 Swal.fire({ icon: "warning", title: v.title, text: v.text });
                return;
                        }
                     }
                    // validate closed openings before saving
                    if (
                      form.openings !== "" &&
                      Number(form.openings) < closedOpenings
                    ) {
                      Swal.fire({
                        icon: "error",
                        title: "Validation Error",
                        text: "Total Openings shall be greater than or equal to Closed Openings",
                      });
                      return;
                    }

                    const openingsChanged = Number(form.openings || 0) !== Number(initialOpenings || 0);

                    const payload = {
                      job_id: form.job_id,
                      job_title: form.job_title,
                      client_id: form.client_id ? Number(form.client_id) : null,
                      min_budget: form.min_budget ? Number(form.min_budget) : null,
                      max_budget: form.max_budget ? Number(form.max_budget) : null,
                      departments: Array.isArray(form.departments) ? form.departments.join(',') : form.departments,
                      years_of_exp: form.years_of_exp,
                      job_desc: form.job_desc,
                      skills: Array.isArray(form.skills) ? form.skills.join(',') : form.skills,
                      locations: form.locations,
                      workmode: form.workmode,
                      job_type: Array.isArray(form.job_type) ? form.job_type.join(',') : form.job_type,
                      notice_period_days: form.notice_period_days,
                      remarks: form.remarks,
                      updated_by: JSON.parse(localStorage.getItem('userData')||'{}').user?.id,
                      openings: form.openings ? Number(form.openings) : null,
                    };

                    try {
                    const res = await updateRequisition(requisitionId, payload);

                  if (res?.result_code === 400) {
                      Swal.fire({
                      icon: "error",
                      title: "Validation Error",
                      text: res.message,
                         });
                      return;
                                 }

                   if (res?.result_code === 200) {
                      if (res.closed_openings !== undefined) {
                         setClosedOpenings(res.closed_openings);
                                       }

                   setInitialOpenings(Number(form.openings || 0));
                   setAllocationAccessGranted(true);

               if (openingsChanged) {
               // Openings changed — show success then force open allocation modal
                await Swal.fire({
                icon: "success",
                title: "Saved",
                text: "Requisition updated. Please adjust recruiter target allocations.",
                confirmButtonText: "Adjust Allocations",
                allowOutsideClick: false,
                         });
                openAllocationModal();
                return;
                   }
// Openings NOT changed — just save and go back
            Swal.fire({ icon: "success", title: "Saved", text: "Requisition updated successfully" });
                navigate("/requisitions");

                       } else {
            Swal.fire({ icon: "error", title: "Error", text: res?.message || "Failed to update requisition" });
                }
                 } catch (err) {
                   console.error(err);
            Swal.fire({ icon: "error", title: "Error", text: "Failed to update requisition" });
                     }
                  }}
                  className="save-btn"
                  style={{ marginLeft: 12 }}
                >
                  Save Changes
                </button>
              </>
            )}
          </div>
        </>
      )}
      {/* Recruiter Allocation Modal */}
      {recruiterModalOpen && roleId === "3" && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.25)",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            className="modal-content"
            style={{
              background: "#fff",
              borderRadius: 10,
              padding: 32,
              minWidth: 500,
              width: "580px",
              boxShadow: "0 2px 16px rgba(0,0,0,0.15)",
            }}
          >
            <h5 style={{ marginBottom: 18, fontWeight: 600 }}>
              Adjust Recruiter Allocations
            </h5>
            <div style={{ marginBottom: 16 }}>
              <label
                style={{ fontWeight: 500, marginBottom: 6, display: "block" }}
              >
                Select Recruiter *
              </label>
              <Select
                isMulti
                isDisabled={isLocked}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{ Option: CheckboxOption }}
                menuIsOpen={recruiterMenuOpen}
                onMenuOpen={() => setRecruiterMenuOpen(true)}
                onMenuClose={() => setRecruiterMenuOpen(false)}
                styles={{
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isSelected ? "#fff" : state.isFocused ? "#f4f5f7" : "#fff",
                    color: state.isDisabled ? "#9ca3af" : "#111",
                    opacity: state.isDisabled ? 0.6 : 1,
                    cursor: state.isDisabled ? "not-allowed" : "pointer",
                  }),
                  multiValue: (provided) => ({
                    ...provided,
                    backgroundColor: "#e2e8f0",
                  }),
                  multiValueLabel: (provided) => ({
                    ...provided,
                    color: "#111",
                  }),
                  multiValueRemove: (provided) => ({
                    ...provided,
                    color: "#6b7280",
                    ':hover': {
                      backgroundColor: '#cbd5e1',
                      color: '#111',
                    },
                  }),
                }}
                options={recruiterOptions}
                controlShouldRenderValue={false}
                value={selectedRecruiters}
                isOptionDisabled={(option) =>
                  selectedRecruiters.some((rec) => String(rec.value) === String(option.value)) &&
                  originalSelectedRecruiters.some((rec) => String(rec.value) === String(option.value))
                }
                onChange={(selected,actionMeta) => {

                  const list = selected || [];
                  const selectAllClicked = list.some((opt) => opt.value === "__select_all__");
                  const regularSelected = list.filter((opt) => opt.value !== "__select_all__");
                  const openings = Number(form.openings || 0);

                  if(actionMeta.action === "clear") {
                      const preserved = selectedRecruiters.filter((rec) =>
                      originalSelectedRecruiters.some(
                      (orig) => String(orig.value) === String(rec.value)
                                      )
                                    );
                  setSelectedRecruiters(preserved);
                  setRecruiterTargets((prev) => {
                  const updated = {};
                  preserved.forEach((rec) => {
                  const key = String(rec.value);
                  updated[key] = prev[key] !== undefined ? prev[key] : 0;
                            });
                  return updated;
                                  });
                   return;
                            }
                  if (selectAllClicked) {
                    const allToSelect = openings > 0 ? recruiterOptions.slice(0, openings) : recruiterOptions;
                    setSelectedRecruiters(allToSelect);
                    setRecruiterTargets((prev) => {
                      const updated = {};
                      allToSelect.forEach((rec) => {
                          const key = String(rec.value);
                          // preserve existing target if present, otherwise default: original recruiters can be 0, new ones empty
                          updated[key] = prev[key] !== undefined ? prev[key] : (isOriginalRecruiter(key) ? 0 : "");
                        });
                      return updated;
                    });
                    return;
                  }
                  if(list.length > openings) {
                    Swal.fire({
                      icon: "warning",
                      title: "Selection Limit",
                      text: `Recruiter count cannot exceed the available openings.`,
                      allowOutsideClick: false,
                    });
                    setRecruiterMenuOpen(true);
                    return;
                  }
                  if (openings === 0 && regularSelected.length > 0) {
                    Swal.fire({
                      icon: "warning",
                      title: "No openings available",
                      text: "Cannot assign recruiters when there are no openings for this requisition.",
                      allowOutsideClick: false,
                    });
                    setRecruiterMenuOpen(true);
                    return;
                  }

                  setSelectedRecruiters(regularSelected);
                  setRecruiterTargets((prev) => {
                    const updated = {};
                    regularSelected.forEach((rec) => {
                      const key = String(rec.value);
                      updated[key] = prev[key] !== undefined ? prev[key] : (isOriginalRecruiter(key) ? 0 : "");
                    });
                    return updated;
                  });
                }}
                getOptionValue={(option) => String(option.value)}
                getOptionLabel={(option) => option.label}
                formatOptionLabel={(option) => `${option.label}`}
                placeholder="Select recruiters..."
              />
            </div>

            {selectedRecruiters.length > 0 && (
              <div style={{ marginTop: "15px", maxHeight: "260px", overflowY: "auto", paddingRight: "4px" }}>
                <h6 style={{ marginBottom: "10px", fontWeight: 600 }}>Selected Recruiters</h6>

              {selectedRecruiters.map((rec) => (
  <div
    key={rec.value}
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "10px 12px",
      border: "1px solid #ddd",
      borderRadius: "6px",
      marginBottom: "8px",
      background: "#f9f9f9",
      gap: "10px",
    }}
  >
    <div style={{ flex: 1, fontWeight: 500 }}>{rec.label}</div>

    <label style={{ minWidth: "50px", fontWeight: 500, marginBottom: 0 }}>Target:</label>

    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
      <button
        type="button"
        disabled={isLocked || recruiterTargets[rec.value] === "" || Number(recruiterTargets[rec.value] || 0) <= (isOriginalRecruiter(rec.value) ? 0 : 1)}
        style={{
          width: "20px", height: "34px", border: "1px solid #ccc",
          borderRadius: "4px", background: "#f4f5f7",
          cursor: (isLocked || recruiterTargets[rec.value] === "" || Number(recruiterTargets[rec.value] || 0) <= (isOriginalRecruiter(rec.value) ? 0 : 1)) ? "not-allowed" : "pointer",
          color: "#111", fontWeight: 700,
        }}
        onClick={() => changeRecruiterTarget(rec, -1)}
      >-</button>

      <input
        type="text"
        disabled={isLocked}
        inputMode="numeric"
        pattern="[0-9]*"
        value={recruiterTargets[rec.value] !== undefined ? recruiterTargets[rec.value] : (isOriginalRecruiter(rec.value) ? 0 : 1)}
        style={{
          width: "50px", padding: "6px 8px", border: "1px solid #ccc",
          borderRadius: "4px", fontSize: "14px",
          cursor: isLocked ? "not-allowed" : "text", textAlign: "center",
        }}
        
        onKeyDown={(e) => {
          // allow control/navigation keys
          const allowed = ["Backspace","Delete","ArrowLeft","ArrowRight","ArrowUp","ArrowDown","Tab","Enter"];
          if (allowed.includes(e.key)) return;

          // if digit, compute prospective value and block if it would exceed openings
          if (e.key.length === 1 && /[0-9]/.test(e.key)) {
            const raw = recruiterTargets[rec.value];
            const currStr = raw === undefined ? "" : String(raw);
            try {
              const inputEl = e.target;
              const start = inputEl.selectionStart ?? currStr.length;
              const end = inputEl.selectionEnd ?? currStr.length;
              const newStr = currStr.slice(0, start) + e.key + currStr.slice(end);
              if (checkExceeded(rec, newStr)) {
                e.preventDefault();
              }
            } catch (err) {
              // fallback: don't block
            }
            return;
          }

          // block any other keys
          if (e.key.length === 1) e.preventDefault();
        }}
        onInput={(e) => { if (checkExceeded(rec, e.currentTarget.value)) return; validateAndSetRecruiterTarget(rec, e.currentTarget.value); }}
        onChange={(e) => { if (checkExceeded(rec, e.target.value)) return; validateAndSetRecruiterTarget(rec, e.target.value); }}
      />

      <button
        type="button"
        disabled={isLocked}
        style={{
          width: "20px", height: "34px", border: "1px solid #ccc",
          borderRadius: "4px", background: "#f4f5f7",
          cursor: isLocked ? "not-allowed" : "pointer", color: "#111", fontWeight: 700,
        }}
        onClick={() => changeRecruiterTarget(rec, 1)}
      >+</button>
    </div>

    {/* Joined count */}
    <div style={{ minWidth: 80, textAlign: "center", fontSize: 13, color: "#374151" }}>
      Selections: <strong>{joinedCounts[String(rec.value)] || 0}</strong>
    </div>
    {/* Remove button */}
   <button
  disabled={isLocked || (submissionCounts[String(rec.value)] || 0) > 0}
  style={{
    background: (submissionCounts[String(rec.value)] || 0) > 0 ? "#9ca3af" : "#ff4444",
    border: "none", color: "white",
    cursor: (isLocked || (submissionCounts[String(rec.value)] || 0) > 0)
      ? "not-allowed" : "pointer",
    fontWeight: "bold",
    padding: "4px 8px", borderRadius: "4px", fontSize: "14px",
  }}
  title={
    (submissionCounts[String(rec.value)] || 0) > 0
      ? "Recruiter cannot be deleted as submission count is greater than zero"
      : "Remove recruiter"
  }
  onClick={async () => {
    const hasSubmissions = (submissionCounts[String(rec.value)] || 0) > 0;
    if (hasSubmissions) {
      await Swal.fire({
        icon: "warning",
        title: "Cannot Remove Recruiter",
        text: "Recruiter cannot be deleted as submission count is greater than zero",
      });
      return;
    }
    setSelectedRecruiters(prev => prev.filter(r => r.value !== rec.value));
    setRecruiterTargets(prev => {
      const copy = { ...prev };
      delete copy[String(rec.value)];
      return copy;
    });
  }}
>
  Remove
</button>
  </div>
))}
</div>
            )}
            {selectedRecruiters
              .filter((r) => {
                const target = Number(recruiterTargets[String(r.value)] || 0);
                const joined = Number(joinedCounts[String(r.value)] || 0);
                return target < joined;
              })
              .map((r) => {
                const target = Number(recruiterTargets[String(r.value)] || 0);
                const joined = Number(joinedCounts[String(r.value)] || 0);
                return (
                  <div
                    key={`warn-${r.value}`}
                    style={{
                      background: "#fef2f2",
                      border: "1px solid #fca5a5",
                      borderRadius: 6,
                      padding: "10px 14px",
                      marginTop: 12,
                      fontSize: 13,
                      color: "#b91c1c",
                    }}
                  >
                    ⚠️ Recruiter <strong>{r.label}</strong> has joined {joined} candidate{joined === 1 ? "" : "s"}, but the target is {target}. Increase the target to at least {joined} before saving to avoid blocking future candidate status updates.
                  </div>
                );
              })}
            
            <div style={{ marginTop: "15px", display: "flex", justifyContent: "space-between", padding: "10px 12px", border: "1px solid #eee", borderRadius: "6px" }}>
              <div>
                <strong>Allocated</strong> {totalAssignedTargets}
              </div>
              <div>
                <strong>Remaining</strong>{" "}
                {Math.max((Number(form.openings) || 0) - totalAssignedTargets, 0)}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 20,
                gap: 12,
              }}
            >
              <button
                disabled={cancelDisabled}
                style={{
                  padding: "0.5rem 1.2rem",
                  background: cancelDisabled ? "#d1d5db" : "#e5e7eb",
                  border: "none",
                  borderRadius: 6,
                  fontWeight: 500,
                  cursor: cancelDisabled ? "not-allowed" : "pointer",
                }}
                onClick={() => {
                  setRecruiterModalOpen(false);
                  setRecruiterMenuOpen(false);
                  // Restore originals instead of wiping
                  setSelectedRecruiters(originalSelectedRecruiters);
                  setRecruiterTargets(originalRecruiterTargets);
                }}
              >
                Cancel
              </button>
              <button
                disabled={isLocked}
                style={{
                  padding: "0.5rem 1.2rem",
                  background: "#0078b9",
                  color: "#fff",
                  border: "none",
                  borderRadius: 6,
                  cursor: isLocked ? "not-allowed" : "pointer",
                  fontWeight: 500,
                }}
                onClick={handleReconcileAllocations}
              >
                Save Allocations
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  </>
  );
}

export default EditRequisition;
